import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "scheduled-emails-toolbar" }
const _hoisted_2 = { class: "typographies-paragraph-medium-bold btn-cancel-selected-items" }

import Feature from 'Services/Feature';
interface SelectedEmail {
    id: string;
}

interface Props {
    selectedEmails?: SelectedEmail[];
    isToolbarVisible?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ScheduledEmailsListingMassActions',
  props: {
    selectedEmails: { default: () => [] },
    isToolbarVisible: { type: Boolean, default: false }
  },
  emits: ["closeToolbar", "open:delete"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const useNewUi: boolean = Feature.isEnabled('new-listing-ui');

const closeToolbar = (): void => {
    emit('closeToolbar');
};

const handleDelete = (): void => {
    emit('open:delete');
};

return (_ctx: any,_cache: any) => {
  const _component_CompassIconButton = _resolveComponent("CompassIconButton")!
  const _component_CompassButton = _resolveComponent("CompassButton")!

  return (_openBlock(), _createBlock(_Transition, { name: "toolbar-slide" }, {
    default: _withCtx(() => [
      (__props.isToolbarVisible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["emails-toolbar-container", { 'listingBatchToolbar--new': _unref(useNewUi) }])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, [
                _createVNode(_component_CompassIconButton, {
                  icon: "close",
                  variant: _ctx.CompassEnums.IconButtonVariant.CONTRAST,
                  onClick: closeToolbar
                }, null, 8 /* PROPS */, ["variant"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t.n__(
                            'common.labels.selected',
                            null,
                            __props.selectedEmails.length,
                            __props.selectedEmails.length,
                        )), 1 /* TEXT */)
              ]),
              _createVNode(_component_CompassButton, {
                label: _ctx.$t.__('common.actions.delete'),
                type: _ctx.CompassEnums.ButtonType.TERTIARY_CONTRAST,
                leftIcon: "bin",
                onClick: handleDelete
              }, null, 8 /* PROPS */, ["label", "type"])
            ])
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}
}

})